import moment from 'moment';

import {
  getDaysAgo,
  getFormattedDate,
  isDataBefore,
} from '../../../shared/utils/dateUtils';
import { DateRange } from '../../interfaces/DateRange';

export const getDefaultDateRange = (registrationDate: string): DateRange => {
  const oneDayAgo = getDaysAgo(1);
  const eightDaysAgo = getDaysAgo(8);
  const registrationDateMoment = moment(registrationDate);

  const isRegisteredBeforeStartDay = isDataBefore(registrationDateMoment, eightDaysAgo);

  const startDate = isRegisteredBeforeStartDay ? eightDaysAgo : registrationDateMoment;

  const isRegisteredBeforeEndDay = isDataBefore(registrationDateMoment, oneDayAgo);

  const endDate = isRegisteredBeforeEndDay ? oneDayAgo : registrationDateMoment;

  return {
    startDate: getFormattedDate(startDate),
    endDate: getFormattedDate(endDate),
  };
};
